import { Helper } from '../Helper';
export class ArrMapFuncHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.getCallable({}));
        sb.emitOp(node, 'SWAP');
        sb.emitOp(node, 'UNPACK');
        sb.emitOp(node, 'DUP');
        sb.emitOp(node, 'INC');
        sb.emitOp(node, 'ROLL');
        sb.emitOp(node, 'SWAP');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'GT');
            },
            each: (innerOptions) => {
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'DUP');
                sb.emitHelper(node, options, sb.helpers.wrapNumber);
                sb.emitOp(node, 'SWAP');
                sb.emitPushInt(node, 5);
                sb.emitOp(node, 'ADD');
                sb.emitOp(node, 'ROLL');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PACK');
                sb.emitOp(node, 'SWAP');
                sb.emitHelper(node, innerOptions, sb.helpers.call);
                sb.emitOp(node, 'OVER');
                sb.emitPushInt(node, 4);
                sb.emitOp(node, 'ADD');
                sb.emitOp(node, 'XTUCK');
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'INC');
                sb.emitOp(node, 'ROT');
            },
            cleanup: () => {
                sb.emitOp(node, 'NIP');
                sb.emitOp(node, 'NIP');
                sb.emitOp(node, 'PACK');
            },
        }));
    }
}

//# sourceMappingURL=ArrMapFuncHelper.js.map
